import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import './index.css';
import App from './App';
import './i18n';
import { starActionStyles } from './styles/actionButton';

if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    .catch((error) => console.warn('No se pudieron desregistrar service workers en desarrollo', error));
}

//https://coolors.co/palette/0081a7-00afb9-fdfcdc-fed9b7-f07167
//https://coolors.co/palette/8ea604-f5bb00-ec9f05-d76a03-bf3100
//https://coolors.co/palette/8ed081-b4d2ba-dce2aa-b57f50-4b543b
//https://coolors.co/palette/22577a-38a3a5-57cc99-80ed99-c7f9cc

const theme = createTheme({
  palette: { // Mi paleta https://coolors.co/d4b99b-479079-3f6e5f-59dfb5-011936
    primary: {
      main: '#22BDD5',
      dark: '#011936',
    },
    lightGray: {
      main: '#8f8f8f',
    },
    // Colores de macronutrientes sincronizados con el sistema de diseño global
    kilocalories: {
      main: '#f093fb', // --macro-kilocalories-color
      light: '#fdf2f8' // --macro-kilocalories-light
    },
    protein: {
      main: '#4ecdc4', // --macro-protein-color
      light: '#ecfdf5' // --macro-protein-light
    },
    fat: {
      main: '#667eea', // --macro-fat-color
      light: '#eef2ff' // --macro-fat-light
    },
    carbs: {
      main: '#fbbf24', // --macro-carbs-color
      light: '#fffbeb' // --macro-carbs-light
    },
    other: {
      whatsapp: '#25D366',
    }
  },
  typography: {
    fontFamily: 'Quicksand, sans-serif',
    h1: {
      fontSize: '3rem',
      fontWeight: '500',
    },
    h3: {
      fontSize: '2rem', 
    },
    h4: {
      fontSize: '1.5rem',
    },
    h5: {
      fontSize: '1.3rem',
    },
    h6: {
      fontSize: '1.1rem',
    },
  },
  components: {
    // Estilo de acción destacada por defecto: los botones rellenos primarios
    // y los Fab primarios/por defecto adoptan el "botón estrella" (degradado
    // violeta + brillo + chispa) sin importar su forma. Los botones con color
    // semántico propio (success, error, secondary, warning...) conservan el suyo.
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          textTransform: 'none',
          ...(ownerState.variant === 'contained' &&
            (ownerState.color === 'primary' || ownerState.color === undefined)
            ? starActionStyles
            : {}),
        }),
      },
    },
    MuiFab: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          textTransform: 'none',
          ...(ownerState.color === 'primary' ||
            ownerState.color === 'default' ||
            ownerState.color === undefined
            ? starActionStyles
            : {}),
        }),
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

